import styled from 'styled-components';

export const OpenNavigation = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background: transparent;
  width: 3.5rem;
  height: 3.5rem;
  border: none;
  cursor: pointer;
  z-index: 120;
  @media (max-width: 739px) {
    display: none;
  }
  span {
    width: 3.5rem;
    height: 0.3rem;
    background: #fff;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    :first-child {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }
    :nth-child(2) {
      opacity: ${({ open }) => (open ? '0' : '1')};
      transform: ${({ open }) => (open ? 'translateX(20px)' : 'translateX(0)')};
    }
    :nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;
